import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import React from 'react';
import Card from '../components/card';
import { style } from '../components/RadioButtons';
import { LoanCard } from './card-lenses';

const options = [
  { text: '0-3 months', value: 'ZeroToThree' },
  { text: '3-6 months', value: 'ThreeToSix' },
  { text: '6+ months', value: 'SixPlus' }
];

const TimeToPurchase = ({ model, onChange, ...cardProps }) => (
  <Card title="When would you like to purchase your property?" {...cardProps}>
    <RadioButtonGroup
      name="purchaseTimeFrame"
      style={style.group}
      valueSelected={model.get('purchaseTimeFrame')}
      onChange={(_, value) => onChange('purchaseTimeFrame', value)}
      selected={model.get('purchaseTimeFrame')}
    >
      {options.map((option, i) => (
        <RadioButton style={style.button} key={i} label={option.text} value={option.value} />
      ))}
    </RadioButtonGroup>
  </Card>
);

TimeToPurchase.id = 'TimeToPurchase';

TimeToPurchase.completed = ({ model }) => model.get('purchaseTimeFrame');

export default LoanCard(TimeToPurchase);



// WEBPACK FOOTER //
// ./src/cards/time-to-purchase.js